/*
	Loading and Contextual Loading
	==============================

	Loading: A service to queue up loading actions and show/hide a page-wide loading
			 indicator when appropriate.
	jvConextualLoadingService: A service to register/unregister and show/hide contextual spinners


	Loading Usage
	-----

	It's totally awesome when you pass in promises like this:

	```
	Loading.queue(myPromise);
	```

	Queued promises are automatically dequeued when they resolve. If you don't
	have any lying around, that's ok too. Just be sure to call `Loading.dequeue()`
	for every `Loading.queue()` you call.


	TODO
	----

	Using ng-animate breaks this for some reason. Need to revisit because
	because animations are cool and I like them.

	===============================================================================================
	ContextualLoading Usage

	Add directive wherever spinner needs to be shown and assign a unique ID to it.
	<span jv-contextual-loading="{{id}}"></span>

	In your controllers, show and hide the spinner.
	jvContextualLoadingService.hide($scope.id);
	jvContextualLoadingService.show($scope.id);

	TODO: Refactor Loading service queueing logic to accomodate ContextualLoading as well.
 */

angular.module('jv.Common.Loading', [])

.config(['$provide', function($provide) {
	var $overlay = $('<div jv-loading />');
	$provide.value('$overlay', $overlay);
}])

.run(['$overlay', function($overlay) {
	$(document.body).append($overlay);
}])

.service('Loading', ['$rootScope','$overlay', '$timeout', function($rootScope, $overlay, $timeout) {

	var _queue = [],
		_delay = 200,
		_doneTimer = null,
		_startTimer = null;

	this.show = false;

	this.queue = function(promise) {
		var dequeue = angular.bind(this, function() {
			this.dequeue();
		});

		_queue.push(promise);
		if (!this.show && !_startTimer) {
			_startTimer = $timeout(angular.bind(this, function() {
				this.show = true;
				_startTimer = null;
			}), _delay);
		}

		if (promise && (promise.$then || promise.then)) {
			promise.$then ? promise.$then(dequeue, dequeue) : promise.then(dequeue, dequeue);
		}
	};

	this.dequeue = function() {
		_queue.pop();
		if (!this.show && _queue.length === 0) {
			$timeout.cancel(_startTimer);
			_startTimer = null;
			$rootScope.$broadcast('doneLoading');
			return;
		}
		if (_doneTimer) {
			$timeout.cancel(_doneTimer);
			_doneTimer = null;
		}
		_doneTimer = $timeout(angular.bind(this, function() {
			if (_queue.length === 0 || (_queue.length === 1 && angular.isUndefined(_queue[0]))) {
				this.show = false;
				_doneTimer = null;
				$rootScope.$broadcast('doneLoading');
			}
		}), _delay);
	};


}])

.directive('jvLoading', ['Loading', function(Loading) {
	return {
		scope: {},
		replace: true,
		// ng-animate breaks this :( otherwise I'd add: ng-animate="\'loading-animate\'"
		template: '<div class="jv-loading-overlay" ng-show="loading.show"><div class="jv-loading-image"></div></div>',
		controller: ['$scope', '$element', function($scope, $element) {
			$scope.loading = Loading;
		}]
	};
}])

.factory('jvContextualLoadingService', [function() {
	var cache = {};
	return {

	_register: function (id, loaderScope) {
		// If no id is passed in, throw an exception.
		if (!id) {
			throw new Error("A Contextual Loader must have an Id to register itself with");
		}

		// Add our loader directive's scope to the cache.
		cache[id] = loaderScope;
	},

	_unregister: function (id) {
		delete cache[id];
	},

	// Show the specified spinner.
	show: function (id) {
	if (cache.hasOwnProperty(id)) {
			var loaderScope = cache[id];
			loaderScope.showSpinner = true;
		}
	},

	// Hide the specified spinner.
	hide: function (id) {
		if (cache.hasOwnProperty(id)) {
			var loaderScope = cache[id];
			loaderScope.showSpinner = false;

		}
	}
	};
}])
.directive('jvContextualLoading', ['jvContextualLoadingService','$timeout',function(jvContextualLoadingService, $timeout) {
	return {
		scope: {
			loaderId: '@jvContextualLoading',
			spinnerId: '@'
		},
		replace: true,
		template: '<div class="jv-contextual-loading-overlay" ng-show="showSpinner"><div class="jv-loading-image"></div></div>',
		link: function($scope,$element,$attrs) {
			var id = $attrs.jvContextualLoading;
			$scope.$watch('showSpinner',function(newVal, oldVal){
				if(newVal){
					$timeout(function(){
						$('#'+$scope.spinnerId).addClass('spin');
					},50);

				}else{
					$timeout(function(){
						$('#'+$scope.spinnerId).removeClass('spin');
					},50);
				}

			});
			if (id) {
				jvContextualLoadingService._register(id, $scope);
				$scope.showSpinner = true;
			}
		}
    };
}]);


